export enum TaskType {

    Standard = 1,
    ResearchSelection = 2

}